import React from 'react';
import { useTranslation } from 'react-i18next';

export function DefinitionListItem({ label, value }) {
  return (
    <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5">
      <dt className="text-sm font-medium uppercase tracking-wide text-ink-400">{label}</dt>
      <dd className="mt-1 text-sm text-ink-100 sm:col-span-2 sm:mt-0">{value}</dd>
    </div>
  );
}

export default function WaybillDetails({ info }) {
  const { t } = useTranslation();
  const {
    code = '',
    receiver = '',
    origin_region = '',
    destination_region = '',
    parcels = '',
    weight = '',
    quantity = '',
  } = info;

  return (
    <div className="container mx-auto">
      <div className="overflow-hidden rounded-2xl border border-white/10 bg-night-700/70 shadow-panel">
        <div className="border-l-4 border-signal-500 px-4 py-5 sm:px-6">
          <h3 className="font-display text-lg font-bold uppercase italic tracking-tight text-signal-400">{t('waybill-details-waybill')} {code}</h3>
          <p className="mt-1 max-w-2xl text-sm text-ink-400">{t('waybill-details-title')}</p>
        </div>
        <div className="border-t border-white/10 px-4 py-5 sm:p-0">
          <dl className="sm:divide-y sm:divide-white/10">
            <DefinitionListItem label={t('waybill-details-receiver-name')} value={receiver} />
            <DefinitionListItem label={t('waybill-details-origin-region')} value={origin_region} />
            <DefinitionListItem label={t('waybill-details-destination-region')} value={destination_region} />
            <DefinitionListItem label={t('waybill-details-parcels')} value={parcels} />
            <DefinitionListItem label={t('waybill-details-weight')} value={`${weight} кг`} />
            <DefinitionListItem label={t('waybill-details-quantity')} value={quantity} />
          </dl>
        </div>
      </div>
    </div>
  )
}